"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClotheType;
(function (ClotheType) {
    ClotheType["BlazerShirt"] = "BlazerShirt";
    ClotheType["BlazerSweater"] = "BlazerSweater";
    ClotheType["CollarSweater"] = "CollarSweater";
    ClotheType["GraphicShirt"] = "GraphicShirt";
    ClotheType["Hoodie"] = "Hoodie";
    ClotheType["Overall"] = "Overall";
    ClotheType["ShirtCrewNeck"] = "ShirtCrewNeck";
    ClotheType["ShirtScoopNeck"] = "ShirtScoopNeck";
    ClotheType["ShirtVNeck"] = "ShirtVNeck";
})(ClotheType || (ClotheType = {}));
exports.default = ClotheType;
